import { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../../states/hooks/useAuth/useAuth';
import { User } from '../../../../types/verification';
import { Button } from '../../../basics';
import { Form, Input, PinVerification, Popover } from '../../../elements';
import PageLayout from '../../../layouts/PageLayout/PageLayout';

type Props = {
    children?: any;
};

const AddSessionPage: FC<Props> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [ showPinPad, setShowPinPad ] = useState(false);
    const [ email, setEmail ] = useState<string>();
    
    const handleSubmit = async (data: any) => {
        setEmail(data.email)
        setShowPinPad(true);
    }
    
    const handleVerificationComplete = (user: User) => {
        setShowPinPad(false)
        
        const redirectedPage = (location?.state as any)?.from;
        if (redirectedPage) {
            navigate(redirectedPage);
        } else {
            navigate('/');
        }
    }
    
    const handleVerificationError = () => {}
    
    return (
        <>
            <PageLayout>
                <div className="mb-6">
                    <div className="pre-heading">Accounts</div>
                    <div className="heading">Toevoegen</div>
                </div>
                <Form onSubmit={ handleSubmit } className="flex-1 flex flex-col">
                    <div className="flex-1">
                        <Input name="email" type="email" placeholder="Emailadres" required />
                    </div>
                    <Button theme="main" type="submit">Aanmelden</Button>
                </Form>
                {/* <p className="text-center text-stone-500 text-sm">
                    <span className="font-semibold">Nog geen account?</span><br />
                    Registreer je hieronder
                </p> */}
            </PageLayout>
            <Popover active={ !!email && showPinPad } onClose={() => setShowPinPad(false)}>
                <PinVerification session={{ email: email || '' }} onComplete={ handleVerificationComplete } onError={ handleVerificationError } />
            </Popover>
        </>
        
    )
}

export default AddSessionPage;